var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rounded-pill py-1 px-4 back-app-color mb-1 d-flex align-center"},[_c('v-icon',{attrs:{"left":""}},[_vm._v("\n    "+_vm._s(_vm.mdiCalendar)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"font-weight-bold mr-auto"},[_vm._v("\n    "+_vm._s(_vm.date)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }